import { MAX_INDIVIDUAL_TAGS } from "./tagLimits";

/**
 * Split sorted tag options into chunks of at most MAX_INDIVIDUAL_TAGS for one-click batch selection.
 * @param {Array<{ label: string, value: string }>} tagOptions
 * @returns {Array<{ id: number, options: typeof tagOptions, rangeLabel: string }>}
 */
export function buildTagBatches(tagOptions) {
  if (!Array.isArray(tagOptions) || tagOptions.length === 0) return [];
  const batches = [];
  for (let i = 0; i < tagOptions.length; i += MAX_INDIVIDUAL_TAGS) {
    const options = tagOptions.slice(i, i + MAX_INDIVIDUAL_TAGS);
    const first = options[0];
    const last = options[options.length - 1];
    const a = (first?.label ?? first?.value ?? "").toString();
    const b = (last?.label ?? last?.value ?? "").toString();
    batches.push({
      id: i,
      options,
      rangeLabel: options.length === 1 ? a : `${a} – ${b}`,
    });
  }
  return batches;
}
